import type React from "react"

export const Print: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Print</title>
    <path
      d="M3.46875 1.5H11.4062L12.5 2.5625V5H14V2.5625C14 2.1875 13.8125 1.78125 13.5312 1.5L12.5 0.46875C12.2188 0.1875 11.8125 0 11.4375 0H3.46875C2.65625 0 2 0.6875 2 1.5V4.09375V5H3.5L3.46875 1.5ZM13.75 6H2.25C1 6 0 7.03125 0 8.25V11.75C0 12.1875 0.3125 12.5 0.75 12.5H2.5V15C2.5 15.5625 2.9375 16 3.5 16H12.5C13.0312 16 13.5 15.5625 13.5 15V12.5H15.25C15.6562 12.5 16 12.1875 16 11.75V8.25C16 7.03125 14.9688 6 13.75 6ZM12 14.5H4V11.5H12V14.5ZM14.5 11H13.5C13.5 10.4688 13.0312 10 12.5 10H3.5C2.9375 10 2.5 10.4688 2.5 11H1.5V8.25C1.5 7.84375 1.8125 7.5 2.25 7.5H13.75C14.1562 7.5 14.5 7.84375 14.5 8.25V11Z"
      fill="#938F94"
    />
  </svg>
)
